export default __webpack_public_path__ + "static/media/video.0e89bd9b.svg";